module.exports = __webpack_public_path__ + "img/telegram.23871be3.svg";